const SLUG_RE = /^[a-z0-9-]{16,}$/;

export function isValidSlug(s: string): boolean {
  return SLUG_RE.test(s);
}

export function parseSlugFromPath(pathname: string): string | null {
  const m = /^\/h\/([^/]+)/.exec(pathname);
  return m?.[1] ?? null;
}

const WORDS = [
  'apple','banana','carrot','dumpling','egg','fig','grape','honey',
  'iglu','jam','kale','lemon','mango','nectar','oat','peach',
  'quince','radish','sage','thyme','udon','vine','wheat','zest',
];

function pickWord(rng: () => number): string {
  return WORDS[Math.floor(rng() * WORDS.length)]!;
}

function randomChars(n: number, rng: () => number): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let out = '';
  for (let i = 0; i < n; i++) out += chars[Math.floor(rng() * chars.length)]!;
  return out;
}

export function generateSlug(rng: () => number = Math.random): string {
  // 3 word-prefix + 32 random chars ≈ 44+ chars, ~180 bits of entropy.
  // Only the entropy matters in practice (the URL is never typed); the words
  // are kept as a small scannable prefix in case anyone glances at the URL.
  return [pickWord(rng), pickWord(rng), pickWord(rng), randomChars(32, rng)].join('-');
}
